import { render, staticRenderFns } from "./AmapTransfermap.vue?vue&type=template&id=b2d53344&scoped=true&"
import script from "./AmapTransfermap.vue?vue&type=script&lang=js&"
export * from "./AmapTransfermap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d53344",
  null
  
)

export default component.exports